export enum SupportContactFrequencyType {
    None = 0,
    Weekly = 1,
    TwoTimesPerWeek = 2,
    Daily = 3,
}
